import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f8583b54"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("显示")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("不显示")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("付费")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("不付费")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_cascader = _resolveComponent("a-cascader")!
  const _component_UploadComponent = _resolveComponent("UploadComponent")!
  const _component_a_form_item_rest = _resolveComponent("a-form-item-rest")!
  const _component_EditorComponent = _resolveComponent("EditorComponent")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { title: "设置文章" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        ref: "formRef",
        model: _ctx.formState,
        rules: _ctx.rules,
        "label-col": _ctx.labelCol,
        "wrapper-col": _ctx.wrapperCol
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            ref: "title",
            label: "文章标题",
            name: "title"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.title,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.title) = $event)),
                placeholder: "请输入"
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "intro",
            label: "文章简介",
            name: "intro"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_textarea, {
                value: _ctx.formState.intro,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.intro) = $event)),
                placeholder: "请输入,1000字以内",
                maxlength: 1000,
                showCount: "",
                autoSize: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "is_intro",
            label: "显示文章简介",
            name: "is_intro"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio_group, {
                value: _ctx.formState.is_intro,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.is_intro) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_component_a_radio, {
                    value: 1,
                    key: 1
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  })),
                  (_openBlock(), _createBlock(_component_a_radio, {
                    value: 0,
                    key: 0
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "if_project",
            label: "是否是项目",
            name: "is_intro"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio_group, {
                value: _ctx.formState.if_project,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.if_project) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_component_a_radio, {
                    value: 1,
                    key: 1
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })),
                  (_openBlock(), _createBlock(_component_a_radio, {
                    value: 0,
                    key: 0
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }, 512),
          (_ctx.formState.if_project==1)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 0,
                ref: "if_project",
                label: "省市区",
                name: "is_intro"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_cascader, {
                    value: _ctx.value,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.value) = $event)),
                    options: _ctx.proList,
                    placeholder: "请选择",
                    onChange: _ctx.onChange,
                    "change-on-select": ""
                  }, null, 8, ["value", "options", "onChange"])
                ]),
                _: 1
              }, 512))
            : _createCommentVNode("", true),
          _createVNode(_component_a_form_item, {
            ref: "formState.isFree",
            label: "是否付费",
            name: "is_intro"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio_group, {
                value: _ctx.formState.isFree,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.isFree) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_component_a_radio, {
                    value: 1,
                    key: 1
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  })),
                  (_openBlock(), _createBlock(_component_a_radio, {
                    value: 0,
                    key: 0
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }, 512),
          (_ctx.formState.isFree == 1)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 1,
                ref: "price",
                label: "售价",
                name: "price"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.price,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formState.price) = $event)),
                    placeholder: "请输入"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }, 512))
            : _createCommentVNode("", true),
          (_ctx.formState.isFree == 1)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 2,
                ref: "source",
                label: "市场价",
                name: "source"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.market_price,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formState.market_price) = $event)),
                    placeholder: "请输入"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }, 512))
            : _createCommentVNode("", true),
          _createVNode(_component_a_form_item, {
            ref: "source",
            label: "文章来源",
            name: "source"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.source,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formState.source) = $event)),
                placeholder: "请输入"
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "tag",
            label: "文章标签",
            name: "tag"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.tag,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formState.tag) = $event)),
                placeholder: "请输入"
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "author",
            label: "文章作者",
            name: "author"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.author,
                "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formState.author) = $event)),
                placeholder: "请输入"
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "edit_user",
            label: "网站编辑",
            name: "edit_user"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.edit_user,
                "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formState.edit_user) = $event)),
                placeholder: "请输入"
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "type",
            label: "类型",
            name: "type"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio_group, {
                value: _ctx.formState.type,
                "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formState.type) = $event)),
                onChange: _ctx.onTypeChange
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articleTypes, (item) => {
                    return (_openBlock(), _createBlock(_component_a_radio, {
                      value: item.id,
                      key: item.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "onChange"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "cid",
            label: "所属分类",
            name: "cid"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_cascader, {
                value: _ctx.formState.cid,
                "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formState.cid) = $event)),
                options: _ctx.category,
                fieldNames: { label: 'name', value: 'id', children: 'children' },
                placeholder: "请选择"
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "image",
            label: "文章封面图",
            name: "image"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.image,
                "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formState.image) = $event)),
                style: {"display":"none"}
              }, null, 8, ["value"]),
              _createVNode(_component_a_form_item_rest, null, {
                default: _withCtx(() => [
                  _createVNode(_component_UploadComponent, {
                    "on-change": _ctx.onImageChange,
                    "source-url": _ctx.formState.image
                  }, null, 8, ["on-change", "source-url"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "image_app",
            label: "文章封面图(app)",
            name: "image_app"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.image_app,
                "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formState.image_app) = $event)),
                style: {"display":"none"}
              }, null, 8, ["value"]),
              _createVNode(_component_a_form_item_rest, null, {
                default: _withCtx(() => [
                  _createVNode(_component_UploadComponent, {
                    "on-change": _ctx.onImageAppChange,
                    "source-url": _ctx.formState.image_app
                  }, null, 8, ["on-change", "source-url"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512),
          ([1, 2].includes(_ctx.formState.type))
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 3,
                ref: "media_image",
                label: _ctx.formState.type === 1 ? '视频封面图' : '音频封面图',
                name: "media_image"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.media_image,
                    "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formState.media_image) = $event)),
                    style: {"display":"none"}
                  }, null, 8, ["value"]),
                  _createVNode(_component_a_form_item_rest, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_UploadComponent, {
                        "on-change": _ctx.onImageCoverChange,
                        "source-url": _ctx.formState.media_image
                      }, null, 8, ["on-change", "source-url"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.formState.type === 1)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 4,
                ref: "media_url",
                label: "视频",
                name: "media_url",
                placeholder: "请输入",
                extra: "可以输入视频网络地址或上传视频"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.media_url,
                    "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formState.media_url) = $event)),
                    class: _normalizeClass({'form_hide': _ctx.formState.type === 0}),
                    style: {"margin-bottom":"10px"}
                  }, null, 8, ["value", "class"]),
                  _createVNode(_component_a_form_item_rest, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_UploadComponent, {
                        "on-change": _ctx.onMediaChange,
                        "source-url": _ctx.formState.media_url,
                        type: "video"
                      }, null, 8, ["on-change", "source-url"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512))
            : _createCommentVNode("", true),
          (_ctx.formState.type === 2)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 5,
                ref: "media_url",
                label: "音频",
                name: "media_url",
                placeholder: "请输入",
                extra: "可以输入音频网络地址或上传音频"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.media_url,
                    "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formState.media_url) = $event)),
                    class: _normalizeClass({'form_hide': _ctx.formState.type === 0}),
                    style: {"margin-bottom":"10px"}
                  }, null, 8, ["value", "class"]),
                  _createVNode(_component_a_form_item_rest, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_UploadComponent, {
                        "on-change": _ctx.onMediaChange,
                        "source-url": _ctx.formState.media_url,
                        type: "audio"
                      }, null, 8, ["on-change", "source-url"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512))
            : _createCommentVNode("", true),
          _createVNode(_component_a_form_item, {
            ref: "url",
            label: "外链",
            name: "url"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.url,
                "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formState.url) = $event)),
                placeholder: "请输入，http或https开头"
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "content",
            label: "内容",
            name: "content",
            placeholder: "请输入"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.content,
                "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formState.content) = $event)),
                class: "form_hide"
              }, null, 8, ["value"]),
              _createVNode(_component_a_form_item_rest, null, {
                default: _withCtx(() => [
                  _createVNode(_component_EditorComponent, {
                    ref: "editorComponentRef",
                    "is-extra": true,
                    content: _ctx.formState.content,
                    extra: _ctx.formState.enclosure
                  }, null, 8, ["content", "extra"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            "wrapper-col": { span: 14, offset: 4 },
            style: {"margin-top":"16px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _ctx.onSubmit,
                loading: _ctx.loading
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["onClick", "loading"]),
              _createVNode(_component_a_button, {
                style: {"margin-left":"10px"},
                onClick: _ctx.goBack,
                loading: _ctx.loading
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }, 8, ["onClick", "loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules", "label-col", "wrapper-col"])
    ]),
    _: 1
  }))
}